
const initialState = () => ({
    isEdit: false,
    spliting: false,
    isMenu:false,
    SE_DATE: new Date(),
    invoice_form: {
        INVOICE_ID: "",
        BILL_ID: "",
        CUSTOMER_ID: "",
        CUSTOMER_NAME: "",
        CUSTOMER_TAX_ID: "",
        CUSTOMER_BRANCH: "",
        CUSTOMER_ADDRESS: "",
        PROVIDER_EMAIL: "",
        CUSTOMER_SUBDISTRICT: "",
        CUSTOMER_DISTRICT: "",
        CUSTOMER_PROVINCE: "",
        CUSTOMER_ZIPCODE: "",
        CUSTOMER_PHONE: "",
        CUSTOMER_NEWPHONE: "",
        PRICE_OPTION: "",
        ISVAT: "",
        ISVAT2: "",
        MEMO: "",
        REMARK: "",
        CREATED_AT: "",
        TOTAL_PRICE: 0,
        VAT_VALUE: "",
        VAT_VALUE2: "",
        TOTAL: 0,
        DOC_DATE: "",
        SIGNATURE: "",
        SPLIT_PAY: "",
        SPLIT_VALUE: "",
        STATUS:"",
        PREVIOUS_VALUE: "",
        TEMP_PREVIOUS_VALUE: "",
        PAID_VAT:"",
        PAID_NO_VAT:"",
        IS_DISCOUNT:"",
        DISCOUNT_TYPE:"",
        DISCOUNT_VALUE:"",
        IS_CONTRACT:true,
        ACTUAL_PAY:"",
        DOC_STATUS:"",
        SPLIT_OPTION: ""
    },
    PRODUCT_LIST: [
        {
            PID: 0,
            QID: "",
            NAME: "",
            DETAIL: "",
            AMOUT: 1,
            UNIT: "",
            PRICE: 0,
            TOTAL_PRICE: 0
        },
    ]
});

const state = initialState()


const getters = {
    GET_INVOICE: state => state.invoice_form,
    GET_SE_DATE: state => state.SE_DATE,
    GET_PRODUCT: state => state.PRODUCT_LIST,
    IS_EDIT: state => state.isEdit,
    IS_MENU: state => state.isMenu,
    SPLITING: state => state.spliting,

}

const mutations = {
    SET_IS_EDIT(state, data) {
        state.isEdit = data
    },
    SET_IS_MENU(state,data){
        state.isMenu = data
    },
    SET_SPLITING(state, data) {
        state.spliting = data
    },
    SET_ALL_ELEMENT(state, data) {
        state.invoice_form = Object.assign({}, data);
    },
    MERGE_ALL_ELEMENT(state, data) {
        let object1 = state.invoice_form
        state.invoice_form = Object.assign(object1, data);
    },
    SET_ELEMENT(state, data) {
        state.invoice_form[data.key] = data.value;
    },
    SET_SE_DATE(state, data) {
        state.SE_DATE = data
    },
    SET_PRODUCT_LIST(state, data) {
        state.PRODUCT_LIST = data
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },

}

const actions = {
    remove_product_list(context, items) {
        let data = context.state.PRODUCT_LIST
        const index = data.indexOf(items)
        data.splice(index, 1);
        context.commit('SET_PRODUCT_LIST', data)
    },
    add_product_list(context, items) {
        let data = context.state.PRODUCT_LIST
        data.push(items)
        data[data.length - 1].INDEX = parseInt(data.length) - 1
        context.commit('SET_PRODUCT_LIST', data)
    },
    reset_product_list(context, items) {
        context.commit('SET_PRODUCT_LIST', [{
            INDEX: 0,
            NAME: "",
            DETAIL: "",
            AMOUT: 1,
            UNIT: "",
            PRICE: 0,
            TOTAL_PRICE: 0
        }])
    },
    reset({ commit }) {
        commit('RESET');
    }
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}